<template>
    <object :data="require(path)" :type="icon + '.svg'"></object>  
</template> 
<script>

export default {
    name: 'IconComponent',
    props: {
        'icon': {
            type: String
        }
    },
    computed: {
        'path': function() {
            return SVGPATH + '/' + this.icon + '.svg';
        } 
    }
}
</script>
